import { StyledList, StyledListItem } from '@/components/AssetsPage/PopoverList';
import { CreateNewFolderRounded, DriveFolderUploadRounded, UploadFileRounded } from '@mui/icons-material';
import { Divider, ListItemIcon, ListItemText } from '@mui/material';

interface NewItemMenuContentProperties {
  onClose: () => void;
  onNewFolderClick: () => void;
  onFileUpload: () => void;
  onFolderUpload: () => void;
  sx?: object;
}

export const NewItemMenuContent = ({
  onClose,
  onNewFolderClick,
  onFileUpload,
  onFolderUpload,
  sx,
}: NewItemMenuContentProperties) => {
  const handleNewFolderClick = () => {
    onNewFolderClick();
    onClose();
  };

  const handleFileUpload = () => {
    onFileUpload();
    onClose();
  };

  const handleFolderUpload = () => {
    onFolderUpload();
    onClose();
  };

  return (
    <StyledList sx={sx}>
      <StyledListItem onClick={handleNewFolderClick}>
        <ListItemIcon>
          <CreateNewFolderRounded sx={{ fontSize: '18px' }} />
        </ListItemIcon>
        <ListItemText>New Folder</ListItemText>
      </StyledListItem>
      <Divider />
      <StyledListItem onClick={handleFileUpload}>
        <ListItemIcon>
          <UploadFileRounded sx={{ fontSize: '18px' }} />
        </ListItemIcon>
        <ListItemText>File Upload</ListItemText>
      </StyledListItem>
      <StyledListItem onClick={handleFolderUpload}>
        <ListItemIcon>
          <DriveFolderUploadRounded sx={{ fontSize: '18px' }} />
        </ListItemIcon>
        <ListItemText>Folder Upload</ListItemText>
      </StyledListItem>
    </StyledList>
  );
};
